import { orange500, blue100 } from "material-ui/styles/colors";

export default {
  primary: "#476F83",
  accent: orange500,
  disable: "#a2a9a9",
  text: "#808080",
  error: "red",
  action: "#6ed8ca",
  navyBlue: "#52829d",
  darkBlue: "#1768A6",
  white: "#ffffff",
  dirtyWhite: "#f5f5f5",
  veryLightBlue: blue100,
  lightBlue: "#f5fcff",
  steelBlue: "#4682b4",
  skyBlue: "#55bedc",
  deepBlue: "#0070d7",
  transparentSkyBlue: "rgba(85, 190, 220, .6)",
  transparentGrey: "rgba(100, 100, 100, .6)",
  steel: "#76919f",
  torquise: "#00a1b9",
  grey: "#8e8e92",
  lightGrey: "#d2d2d2",
  darkGrey: "#676767",
  orange: "#ffa528",
  curiousBlue: "#476F83",
  nileBlue: "#173E51",
  red: "red",
  transparentOrange: "rgba(255, 173, 0, .4)",
  tipGrey: "#bfbfbf",
};

export const colorsV2 = {
  main: "#476F83",
  primary: "#476F83",
  accent: "#FAA22B",
  lightningYellow: "#FAA22B",
  lightYellowBG: "rgba(250, 162, 43, 0.13)",
  viking: "#4BADC1",
  lightViking: "rgba(71, 111, 131, 0.26)",
  darkGray: "#A7A7A7",
  codGray: "#181818",
  mercurySolid: "#E5E5E5",
  silverChalice: "#A1A1A1",
  darkSilverChalice: "#B0B0B0",
  alto: "#D3D3D3",
  bunting: "#1B1A57",
  mineShaft: "#242323",
  santasGray: "#9B9AA7",
  lightCodeGray: "rgba(24, 24, 24, 0.35)",
  tundora: "#404040",
  fauxBrightGray: "#F7F9F9",
  white: "#ffffff",
};



// WEBPACK FOOTER //
// ./src/styles/colors.js